import React from 'react';
import PropTypes from 'prop-types';

import './Background.sass';

import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {CSSTransitionGroup} from 'react-transition-group';

import {channelImageUrl} from '../../containers/channelUtils/ChannelImage';

import bgMain from './assets/bg_main.jpg';
import bgMainWebp from './assets/bg_main.webp';
import bgMainMobile from './assets/bg-main-mobile.jpg';
import bgMainMobileWebp from './assets/bg-main-mobile.webp';

import bgInner from './assets/bg_inner.jpg';
import bgInnerWebp from './assets/bg_inner.webp';
import bgInnerMobile from './assets/bg_inner-mobile.jpg';
import bgInnerMobileWebp from './assets/bg_inner-mobile.webp';

import {BG_DEFAULT, BG_HOMEPAGE} from '../../ducks/ui';

export const closestBackgroundImage = (...taxons) => {
  const closestBackgroundTaxon = taxons.find(
    taxon => !!taxon.images && taxon.images.some(image => image.type === 'background')
  );

  if (closestBackgroundTaxon) {
    return closestBackgroundTaxon.images.find(image => image.type === 'background');
  }

  return undefined;
};

@connect(({ui}) => ({background: ui.background}))
@withRouter
export default class Background extends React.PureComponent {
  render() {
    const {location, background} = this.props;

    if (location.pathname === '/' || background.path === BG_HOMEPAGE.path) {
      return (
        <div className="background background--homepage">
          <picture>
            <source media="(min-width: 768px)" srcSet={bgMainWebp} type="image/webp"/>
            <source media="(max-width: 767px)" srcSet={bgMainMobileWebp} type="image/webp"/>

            <source media="(min-width: 768px)" srcSet={bgMain} type="image/jpeg"/>
            <source media="(max-width: 767px)" srcSet={bgMainMobile} type="image/jpeg"/>

            <img src={bgMain}  className="background__image" alt="Background image for homepage"/>
          </picture>
        </div>
      );
    }

    return (
      <CSSTransitionGroup
        component="div"
        className="background"
        transitionName="fade"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        {background.path !== BG_DEFAULT.path ? (
          <img src={channelImageUrl(background.path)} className="background__image" alt="Background image for inner page"/>
        ) : (
          <picture>
            <source media="(min-width: 768px)" srcSet={bgInnerWebp} type="image/webp"/>
            <source media="(max-width: 767px)" srcSet={bgInnerMobileWebp} type="image/webp"/>

            <source media="(min-width: 768px)" srcSet={bgInner} type="image/jpeg"/>
            <source media="(max-width: 767px)" srcSet={bgInnerMobile} type="image/jpeg"/>

            <img src={bgInner} className="background__image" alt="Background image for inner page"/>
          </picture>
        )}
      </CSSTransitionGroup>
    );
  }
}

Background.propTypes = {
  homepage: PropTypes.bool
};



// WEBPACK FOOTER //
// ./components/background/Background.js